var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDiscover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_discover",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icn_discover-2",
    "data-name": "icn_discover",
    d: "M122.668,130.945l-.431-.748a7.135,7.135,0,0,1-6.425-6.433l-.752-.434a.279.279,0,0,1-.143-.246.289.289,0,0,1,.143-.247l.752-.434a7.126,7.126,0,0,1,6.425-6.432l.43-.748a.3.3,0,0,1,.495,0l.431.748a7.133,7.133,0,0,1,6.429,6.43l.751.434a.289.289,0,0,1,.144.248.284.284,0,0,1-.144.246l-.751.434a7.139,7.139,0,0,1-6.427,6.433l-.433.748a.282.282,0,0,1-.246.145A.286.286,0,0,1,122.668,130.945Zm-4-12.106a6,6,0,1,0,4.244-1.756,6.013,6.013,0,0,0-4.244,1.756Zm.14,8.353a.138.138,0,0,1-.033-.136l3.052-5.081,5.038-3.023a.135.135,0,0,1,.056-.012.136.136,0,0,1,.1.039.145.145,0,0,1,.032.151l-3.023,5.041-5.083,3.054a.126.126,0,0,1-.035,0,.136.136,0,0,1-.1-.038Zm1.383-1.386,3.411-2.048-1.365-1.365Z",
    transform: "translate(-93.916 -25.09)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discover.daeeeb74.svg";
export { ForwardRef as ReactComponent };